<div class="back-wrapper" (click)="back()">
    <div class="back" *ngIf="!close"></div>
    <app-close-round *ngIf="close" width="24" height="24"></app-close-round>
</div>
